module.exports = __webpack_public_path__ + "87ed095b720e1b797ec16e89a3314a7d.MP3";